import { __decorate, __metadata } from "tslib";
import { E_ConfirmResult } from 'library-components/utils/task';
import { Vue, Component, Prop } from 'vue-property-decorator';
let TermsOfServiceUpdateImpl = class TermsOfServiceUpdateImpl extends Vue {
    get TermsTitle() {
        return this.termsUpdate ? this.$t('passport.terms_of_us_title_update') : this.$t('passport.terms_of_us_title');
    }
    get TermsMessage() {
        return this.termsUpdate
            ? this.$t('passport.terms_of_us_title_template_update', {
                policyUrl: this.termsData.privacyPolicy,
                legalTrailUrl: this.termsData.termsOfService,
            })
            : this.$t('passport.terms_of_us_title_template', {
                policyUrl: this.termsData.privacyPolicy,
                legalTrailUrl: this.termsData.termsOfService,
            });
    }
    onCancel() {
        this.$emit('result', E_ConfirmResult.CANCEL);
    }
    onConfirm() {
        this.$emit('result', E_ConfirmResult.CONFIRM);
    }
};
__decorate([
    Prop({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], TermsOfServiceUpdateImpl.prototype, "termsUpdate", void 0);
__decorate([
    Prop({
        type: Object,
        default: () => ({}),
    }),
    __metadata("design:type", Object)
], TermsOfServiceUpdateImpl.prototype, "termsData", void 0);
TermsOfServiceUpdateImpl = __decorate([
    Component({
        name: 'TermsOfServiceUpdate',
    })
], TermsOfServiceUpdateImpl);
export { TermsOfServiceUpdateImpl };
